<template>
  <HomeLayout2 :key="responseData.content.blocks.length"
    v-if="this.templateCheck === 'home-with-default' && responseData"
    :homeLayout2Data="responseData"
  />
  
  <HomeLayout1 :key="responseData.content.blocks.length" v-else-if="responseData" :homeLayout1Data="responseData" />
</template>

<script>
import HomeLayout1 from "@/pages/HomeLayout1";
import HomeLayout2 from "@/pages/HomeLayout2";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "Home",
  data: function () {
    return {
      responseData: "",
      templateCheck: "",
    };
  },
  components: {
    HomeLayout1,
    HomeLayout2,
  },
  mounted: function () {
    HttpService.getHomePage(
      this.$root.wp_country && this.$root.wp_country != ""
        ? this.$root.wp_country
        : this.$cookies.get("wp-country"),
      this.$root.wp_state && this.$root.wp_state != ""
        ? this.$root.wp_state
        : this.$cookies.get("wp-state"),
      this.$root.user_id,
      this.isPreview
    )
      .then((res) => {
        const resData1 = res.data.data;
        this.templateCheck = resData1.hasOwnProperty("template")
          ? resData1.template
          : "";
        if (this.templateCheck === "home-with-default") {
          this.responseData = resData1;
        } else {
          this.responseData = resData1;
        }
        this.$root.loading = false;
        setTimeout(() => {   
        if(res.status == 200) {
          HttpService.getHomepagewithscroll(
            this.$root.wp_country && this.$root.wp_country != ""
              ? this.$root.wp_country
              : this.$cookies.get("wp-country"),
            this.$root.wp_state && this.$root.wp_state != ""
              ? this.$root.wp_state
              : this.$cookies.get("wp-state"),
            this.$root.user_id,
            this.isPreview
          )
          .then((res) => {
            const resData2 = res.data.data;
            this.templateCheck = resData2.hasOwnProperty("template")
              ? resData2.template
              : "";
            if (this.templateCheck === "home-with-default") {
              this.responseData.content.blocks = this.responseData.content.blocks.concat(resData2.content.blocks);
            } else {
              this.responseData.content.blocks = this.responseData.content.blocks.concat(resData2.content.blocks);
            }
            this.$root.loading = false;
            this.$root.body_loading_status = true;
          })
          .catch((err) => console.log(err));
        }
        }, 2000);
      })
      .catch((err) => console.log(err));

  },
  beforeCreate: function () {
    this.$root.loading = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue